module.exports = __webpack_public_path__ + "img/vscode.a500cc7b.png";